import React from 'react';
import resolvePath from '../../misc/resolvePath';
import BlockLink from '../elements/Blocklink/Blocklink';
import { dialogAlert } from '../elements/Dialog/dialogs';
import Input from '../elements/forms/Input';
import TopBar from '../elements/TopBar/TopBar';
import TopBarEvent from '../elements/TopBar/TopBarEvent';
import Screen from './Screen';

export default class SendEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subject: '',
            message: '',
        };
    }
    render() {
        let {user, event, i18n} = this.props,
            header = (
                <div>
                    {event ? (
                        <TopBarEvent event={event} returnURL="..">
                            {i18n['label.message']}
                        </TopBarEvent>
                    ) : (
                        <TopBar returnURL="..">{i18n['label.message']}</TopBar>
                    )}
                </div>
            );

        return (
            <Screen header={header}>
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <div className="content">
                        <Input type="text" label={i18n['label.subject']} value={this.state.subject} onChange={this.handleChange.bind(this, 'subject')} />
                        <Input
                            type="textarea"
                            label={i18n['label.message']}
                            value={this.state.message}
                            onChange={this.handleChange.bind(this, 'message')}
                            rows={5}
                        />
                    </div>
                    <BlockLink type="submit" next customColor={event ? event.settings.primary_color : null} right>
                        {i18n['button.send']}
                    </BlockLink>
                </form>
            </Screen>
        );
    }
    async handleSubmit(e) {
        e.preventDefault();

        let subject = this.state.subject.trim(),
            message = this.state.message.trim(),
            {i18n, user} = this.props;
        if (!subject) {
            await dialogAlert(i18n["label.subject.field.can't.be.empty"]);
            return;
        } else if (!message) {
            await dialogAlert(i18n["label.message.field.can't.be.empty"]);
            return;
        }
        app.store.dispatch(app.actions.ui.busy());
        app.api.misc
            .sendEmail(user.id, subject, message)
            .then(async response => {
                await dialogAlert(i18n['label.successfully.sent']);
                app.history.push(resolvePath(app.history.location.pathname, '..'));
            })
            .catch(async e => {
                console.warn(e);
                await dialogAlert(i18n['label.message.not.send']);
            })
            .then(() => {
                app.store.dispatch(app.actions.ui.free());
            });
    }
    handleChange(field, value) {
        this.setState({[field]: value});
    }
}
